import React, { Component } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { UtilService } from 'hay-core-react';
// Botão + moldura de celular pra visualizar o reactcaptive com a aparência atual (tema/imagem da
// tela inicial). Mesmo padrão visual do "Teste de Acesso" de RouterboardTemplate.js, mas aqui sem
// nenhum parâmetro extra na URL (nem ipconcentrador) — não simula uma Routerboard/fluxo de login
// real, só abre auth.urlCaptiveTeste como está, só pra conferir a aparência aplicada.
//
// auth.urlCaptiveTeste aponta pra Configuracao ativa já PERSISTIDA no banco — sem salvar antes, o
// preview mostraria a última versão salva, não o que está sendo editado no formulário no momento do
// clique. Por isso, recebendo `contexto` (do EntityGrid, no formulário em grid, ou do
// buildContexto/buildContextoSimples da ConfiguracaoPage, no formulário simples), salva antes de
// abrir o dialog: `contexto.salvar(false)` no caso do EntityGrid não fecha o dialog de edição
// (fecharAoSalvar=false); os wrappers de ConfiguracaoPage ignoram esse argumento pois não têm dialog
// pra fechar.
class TesteAparenciaCaptiveButton extends Component {
    state = { visivel: false, salvando: false };

    async abrir() {
        this.setState({ salvando: true });
        try {
            await this.props.contexto?.salvar?.(false);
        } finally {
            this.setState({ salvando: false, visivel: true });
        }
    }

    render() {
        const auth = UtilService.getLocalStorage('auth');
        return (
            <>
                <Button
                    type="button"
                    label={UtilService.traduzir('main.configuracao.testaraparencia')}
                    icon="pi pi-mobile"
                    outlined
                    loading={this.state.salvando}
                    disabled={!auth?.urlCaptiveTeste}
                    onClick={() => this.abrir()}
                />
                <Dialog
                    header={UtilService.traduzir('main.configuracao.testaraparencia')}
                    visible={this.state.visivel}
                    onHide={() => this.setState({ visivel: false })}
                    contentStyle={{ display: 'flex', justifyContent: 'center' }}
                    style={{ width: 'fit-content' }}
                >
                    <div style={{
                        width: '375px',
                        height: '667px',
                        border: '10px solid #222',
                        borderRadius: '36px',
                        overflow: 'hidden',
                        boxShadow: '0 0 0 2px #555',
                    }}>
                        {this.state.visivel && (
                            <iframe
                                title="teste-aparencia-captive"
                                src={auth?.urlCaptiveTeste}
                                style={{ width: '100%', height: '100%', border: 'none' }}
                            />
                        )}
                    </div>
                </Dialog>
            </>
        );
    }
}

export default TesteAparenciaCaptiveButton;
